import apiRequest from './apiRequest';

export default async function putMediaName(mediaID: string, mediaName: string) {
  const { data, error } = await apiRequest(
    'mogen-orchestration',
    `/media/${mediaID}`,
    {
      method: 'PUT',
      body: JSON.stringify({ mediaName }),
    },
  );

  return { data, error };
}
